import { render, staticRenderFns } from "./SwamtStart25.vue?vue&type=template&id=a3aed86e&scoped=true"
import script from "./SwamtStart25.vue?vue&type=script&lang=js"
export * from "./SwamtStart25.vue?vue&type=script&lang=js"
import style0 from "./SwamtStart25.vue?vue&type=style&index=0&id=a3aed86e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3aed86e",
  null
  
)

export default component.exports